import * as yup from 'yup';
import { constantesRequerimentos } from '@utils';
import docs from './attachments';
import {
  aceite,
  declaracaoTipoRegime,
  tipoRegime,
  abatimentoDoEmprestimoCondicional,
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  boletoEmprestimoObrigatorio,
  consentimentoDescontoFolha,
  consentimentoDadosSensiveis,
  estaAposentadoINSS,
  foiJulgado,
  houveProcessoJudicial,
  parcelaAVista,
  consentimentoBeneficio,
  retiradaAVistaMAT,
  aceiteInss,
  consentimentoAjustePagamento,
  declaracaoVeracidade,
} from './utils/rulesByKey';

const {
  VITALICIA_S_R_RCM,
  VITALICIA_C_R_RCM,
  CONJUGADA_S_R_RCM,
  CONJUGADA_C_R_RCM,
  TEMPORARIA_FIXO,
  TEMPORARIA_VARIAVEL,
} = constantesRequerimentos;

export const MATSchema = (saldoDevedor, limiteMaximoRetirada) => {
  if (saldoDevedor) {
    return yup.object({
      opcaoBeneficio: yup
        .string()
        .oneOf(
          [
            VITALICIA_S_R_RCM,
            VITALICIA_C_R_RCM,
            CONJUGADA_S_R_RCM,
            CONJUGADA_C_R_RCM,
            TEMPORARIA_FIXO,
            TEMPORARIA_VARIAVEL,
          ],
          'Obrigatório assinalar uma opção.'
        )
        .required(),

      percentualRCM: yup
        .number()
        .integer()
        .when('opcaoBeneficio', {
          is: (value) => [VITALICIA_C_R_RCM, CONJUGADA_C_R_RCM].includes(value),
          then: (field) =>
            field
              .min(1, 'Valor deve estar entre 1 e 100')
              .max(100, 'Valor deve estar entre 1 e 100')
              .required('Atenção, Selecione o Percentual de RCM'),
        }),

      percentualRetiradaMensal: yup
        .number()
        .float(2, 'Máximo de duas casas após a virgula')
        .when('opcaoBeneficio', {
          is: (value) =>
            [
              TEMPORARIA_VARIAVEL,
              CONJUGADA_S_R_RCM,
              CONJUGADA_C_R_RCM,
            ].includes(value),
          then: (field) =>
            field
              .min(0.1, 'Valor deve estar entre 0.10 e 1')
              .max(1, 'Valor deve estar entre 0.10 e 1')
              .required('Atenção, Preencha o Percentual de retirada mensal'),
        }),

      percentualSaldoDeContasEmRendaVitalicia: yup
        .number()
        .integer()
        .when('opcaoBeneficio', {
          is: (value) => [CONJUGADA_S_R_RCM, CONJUGADA_C_R_RCM].includes(value),
          then: (field) =>
            field
              .min(50, 'Valor deve estar entre 50 e 99')
              .max(99, 'Valor deve estar entre 50 e 99')
              .required('Atenção, Selecione o Percentual em Renda Vitalícia'),
        }),

      prazo: yup.string().when('opcaoBeneficio', {
        is: TEMPORARIA_FIXO,
        then: (field) => field.required('Atenção, Selecione o Prazo'),
      }),

      ...consentimentoBeneficio,
      ...parcelaAVista,
      ...retiradaAVistaMAT(limiteMaximoRetirada),

      ...consentimentoDadosSensiveis(),
      ...estaAposentadoINSS,
      ...houveProcessoJudicial,
      ...foiJulgado(true),
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...adiantamentoQuinzenal,
      ...consentimentoDescontoFolha,
      ...boletoEmprestimoObrigatorio,
      ...abatimentoDoEmprestimoCondicional,
      ...docs.MATDocs.rules,
      ...aceiteInss,
      ...declaracaoTipoRegime,
      ...aceite,
      ...tipoRegime,
      ...consentimentoAjustePagamento,
      ...declaracaoVeracidade,
      processoJudicial: yup.number().when('houveProcessoJudicial', {
        is: 'Sim',
        then: yup
          .number()
          .required(
            'Atenção! Preencha o número do processo que originou a aposentadoria.'
          ),
      }),
    });
  }

  return yup.object({
    opcaoBeneficio: yup
      .string()
      .oneOf(
        [
          VITALICIA_S_R_RCM,
          VITALICIA_C_R_RCM,
          CONJUGADA_S_R_RCM,
          CONJUGADA_C_R_RCM,
          TEMPORARIA_FIXO,
          TEMPORARIA_VARIAVEL,
        ],
        'Obrigatório assinalar uma opção.'
      )
      .required(),

    percentualRCM: yup
      .number()
      .integer()
      .when('opcaoBeneficio', {
        is: (value) => [VITALICIA_C_R_RCM, CONJUGADA_C_R_RCM].includes(value),
        then: (field) =>
          field
            .min(1, 'Valor deve estar entre 1 e 100')
            .max(100, 'Valor deve estar entre 1 e 100')
            .required('Atenção, Selecione o Percentual de RCM'),
      }),

    percentualRetiradaMensal: yup
      .number()
      .float(2, 'Máximo de duas casas após a virgula')
      .when('opcaoBeneficio', {
        is: (value) =>
          [TEMPORARIA_VARIAVEL, CONJUGADA_S_R_RCM, CONJUGADA_C_R_RCM].includes(
            value
          ),
        then: (field) =>
          field
            .min(0.1, 'Valor deve estar entre 0.10 e 1')
            .max(1, 'Valor deve estar entre 0.10 e 1')
            .required('Atenção, Preencha o Percentual de retirada mensal'),
      }),

    percentualSaldoDeContasEmRendaVitalicia: yup
      .number()
      .integer()
      .when('opcaoBeneficio', {
        is: (value) => [CONJUGADA_S_R_RCM, CONJUGADA_C_R_RCM].includes(value),
        then: (field) =>
          field
            .min(50, 'Valor deve estar entre 50 e 99')
            .max(99, 'Valor deve estar entre 50 e 99')
            .required('Atenção, Selecione o Percentual em Renda Vitalícia'),
      }),

    prazo: yup.string().when('opcaoBeneficio', {
      is: TEMPORARIA_FIXO,
      then: (field) => field.required('Atenção, Selecione o Prazo'),
    }),

    ...consentimentoBeneficio,
    ...parcelaAVista,
    ...retiradaAVistaMAT(limiteMaximoRetirada),
    ...consentimentoDadosSensiveis(),
    ...estaAposentadoINSS,
    ...houveProcessoJudicial,
    ...foiJulgado(true),
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...adiantamentoQuinzenal,
    ...consentimentoDescontoFolha,
    ...docs.MATDocs.rules,
    ...aceiteInss,
    ...declaracaoTipoRegime,
    ...aceite,
    ...tipoRegime,
    ...consentimentoAjustePagamento,
    ...declaracaoVeracidade,
    processoJudicial: yup.number().when('houveProcessoJudicial', {
      is: 'Sim',
      then: yup
        .number()
        .required(
          'Atenção! Preencha o número do processo que originou a aposentadoria.'
        ),
    }),
  });
};
export const MATInitialValues = {
  opcaoBeneficio: '',
  percentualRCM: '',
  percentualRetiradaMensal: '',
  percentualSaldoDeContasEmRendaVitalicia: '',
  prazo: '',
  consentimentoBeneficio: '',
  parcelaAVista: '',
  retiradaAVista: '',
  consentimentoDadosSensiveis: false,
  estaAposentadoINSS: '',
  houveProcessoJudicial: '',
  processoJudicial: '',
  foiJulgado: '',
  acessoContraCheque: '',
  acessoJornalForluz: '',
  adiantamentoQuinzenal: '',
  consentimentoDescontoFolha: false,
  aceiteInss: false,
  boletoEmprestimo: '',
  abatimentoDoEmprestimoCondicional: '',
  aceite: '',
  tipoRegime: '',
  declaracaoTipoRegime: false,
  ...docs.MATDocs.initialValues,
};

export const MATDocs = {
  ...docs.MATDocs.docs,
};
